export default __webpack_public_path__ + "static/worker-holding-metal-sheet-8045ccfd8a2e5b5fb172f1a587114aa5.jpg";